import { isValidNumber } from 'libphonenumber-js';

const validatePhoneNumber = (phoneNumber) => isValidNumber(phoneNumber, 'US');

export { validatePhoneNumber };
